import React from 'react';
import {useAuthService} from "@stores/AppStateContext";


import {GoogleIcon} from "../../../../components/icons/login/GoogleIcon";
import {FacebookIcon} from "../../../../components/icons/login/FacebookIcon";
import {getInviteInfoFromLink} from "../../../../../actions/invite";

import {Button} from "../../../../components/Button";


import './SocialSignInRow.css';
import {getUTMFromCookie} from "../../../../../utils/googleTagManager";


export interface SocialSignInRowProps {
    lineText: string;
}

export const SocialSignInRow = ({lineText}: SocialSignInRowProps) => {
    const authService = useAuthService();
    
    const signInWithGoogle = async (event: any) => {
        await authService.signInWithRedirect("Google");
        event.stopPropagation();
        event.preventDefault();
    }
    
    const signInWithFacebook = async (event: any) => {
        await authService.signInWithRedirect("Facebook");
        event.stopPropagation();
        event.preventDefault();
    }
    const inviteInfo = getInviteInfoFromLink();
    if (inviteInfo) {
        /* https://logycore.atlassian.net/browse/LGC-105 hide till invite implemented for social sign up */
        return null;
    }

    return (
        <div className={'SocialSignInRow'}>
            <div className={'SocialSignInRow__divider label-large'}>{lineText}</div>
            <div className={'SocialSignInRow__btn-row'}>
                <Button
                    className={'SocialSignInRow__btn'}
                    text={'Google'}
                    size={'lg'}
                    style={'outlined'}
                    type={'neutral'}
                    onClick={signInWithGoogle}
                    Icon={GoogleIcon}
                />
                <Button
                    className={'SocialSignInRow__btn'}
                    text={'Facebook'}
                    size={'lg'}
                    style={'outlined'}
                    type={'neutral'}
                    onClick={signInWithFacebook}
                    Icon={FacebookIcon}
                />
            </div>
        </div>
    );
}
